import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServiciosService } from 'src/app/services/inventario/servicios.service';
import { DoctoresService } from 'src/app/services/personas/doctores.service';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-subir-imagenes-analisis',
    templateUrl: './subir-imagenes-analisis.component.html',
    styleUrls: ['./subir-imagenes-analisis.component.scss'],
    standalone: false
})
export class SubirImagenesAnalisisComponent implements OnInit {

  public nombrePaciente:string = "";
  public nombreDoctor: string = "";
  detalleOrden: any[] = [];
  public metodosPagos:string = "Efectivo";
  public talonarioDocotor:string = "";
  detalleOrdenNew: any[] = [];  
  public idOrden: string = "";
  public spinnerBoolean: boolean = false;
  public cargando: string = "Obteniendo información por favor espere....";
  public txtOrdenFisica: string = "";
  public linkOF: string = "";
  public numeroOrden: string = ""
  private baseSistema: string = environment.systemLegacyUrl;

  constructor(    public route: ActivatedRoute,
    public router: Router,
    private ordenesService: OrdenesService,
    private serviciosService: ServiciosService,
    private doctoresService: DoctoresService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

    var idOrden = this.route.snapshot.paramMap.get('id')!.toString().substring(100,this.route.snapshot.paramMap.get('id')!.toString().length-100);
    this.idOrden = idOrden;
    this.spinnerBoolean = true;

    this.ordenesService.mostrarOrdenesNormal(localStorage.getItem('token'),"normal","COD_ORD", idOrden).subscribe((resp) => {
      var content = JSON.parse(JSON.stringify(resp.rows));

      this.nombrePaciente = content[0].NOM_CLI;
      this.nombreDoctor = content[0].NOM_DOC;
    
      this.linkOF = content[0].ordenFisica;
      this.numeroOrden = content[0].NUM_ORD
        /* -------------------------------------------------------------------------- */
      /*                              DATOS DEL DOCTOR                              */
      /* -------------------------------------------------------------------------- */
      this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"CodVendedor", content[0].CODN_DOC).subscribe((resp) => {
        this.talonarioDocotor = content[0].Abreviatura;

      });

      var preciosSelect :any[] = [];

       /* -------------------------------------------------------------------------- */
       /*                             DETALLE DE LA ORDEN                            */
       /* -------------------------------------------------------------------------- */

      
      
        var content = JSON.parse(content[0].DET_ORD);
        content.forEach((currentValue, index) => {
        
          preciosSelect.push({
           
            "precio" :  currentValue.precio1,


            },{

              "precio" :currentValue.precio2,


          },{

              "precio" :  currentValue.precio3,


          },{

            "precio" :currentValue.precio4,


          });

       
          this.detalleOrden.push({
  
            id: currentValue.id,
            producto: currentValue.producto,
            codigo : currentValue.codigo,
            valor: currentValue.valor,
            pieza:  currentValue.pieza,
            agregado: " ",
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto:  currentValue.impuesto,
            incluidoIva:  currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo:currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos:[],
            videosBase:[],
            documentos:[],
            documentosBase:[],
            imagenesSubidas: currentValue.imagenesSubidas
            ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
            : [],
          documentosSubidos: currentValue.documentosSubidos
            ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
            : [],
          videosSubidos: currentValue.videosSubido
            ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
            : [],
            verImagenesSubidas: currentValue.imagenesSubidas
            ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
            : [],
            enviado: currentValue.enviado
          });
                 

        });


        this.detalleOrden.forEach((orden, i) => {
          orden.verImagenesSubidas.forEach(imagen => {
            if(imagen.guardadoServidor){
       imagen.imagen = (typeof imagen.imagen === 'string' && imagen.imagen.includes('amazonaws'))
  ? imagen.imagen
  : this.baseSistema + "/radiografia/vistas/img/multimedia/" + imagen.imagen;
            }else{
              //obtiene del drive y guarda en el servidor
              this.getUrL(imagen); 
            }
            // Llama a getUrL para cada imagen
          });
        });
       
       
       this.spinnerBoolean = false;
    })

  }

  visualizarOrdenFisica(){
    let linkFile = this.linkOF;
    if(linkFile.includes("doc")){
      window.open(`https://www.sistema.cmsalud.ec/radiografia/vistas/img/multimedia/${this.linkOF}`,"_blank");
    }else{
      window.open(`http://drive.google.com/uc?export=view&id=${this.linkOF}`,"_blank");
    }
  }

  getUrL(img: any) {
    console.log(img.imagen)
    this.ordenesService.getImageServer(img.imagen, localStorage.getItem('token'))
      .subscribe((resp) => {
        img.imagen = resp; // Actualiza la propiedad 'url' del objeto de imagen
      });
  }

  volverAtras(){
    this.router.navigateByUrl('sistema/inicio');
  }

  /* -------------------------------------------------------------------------- */
  /*                           REMOVER IMAGEN DROPZONE                          */
  /* -------------------------------------------------------------------------- */
  onRemove(event: any,files, filesBase) {
    files.splice(files.indexOf(event), 1);
  }	

  imgBase(){
    this.detalleOrden.map((item) => {
      item.imagenes.map((item1) => {
        const file = item1;
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async () => {
         await item.imagenesBase.push({
              "imagenes" : reader.result
            })
        };
      });
    });
   
    
  }


  /* -------------------------------------------------------------------------- */
  /*                         SELECCIONAR IMAGEN DROPZONE                        */
  /* -------------------------------------------------------------------------- */
  onSelect(event: any, files, filesBase,tipo) {
    files.push(...event.addedFiles);
  }

  /* -------------------------------------------------------------------------- */
  /*                          ELIMINAR ITEMS DOCUMENOS                          */
  /* -------------------------------------------------------------------------- */
  borrarItem(array,verArray, index){
    array.splice(index, 1);
    verArray.splice(index, 1);
  }

  async subirImagenes() {

    var bandera = true;
    await this.imgBase();
    this.cargando = "Subiendo imágenes a la nube C&M por favor espere...."
    this.spinnerBoolean = true;
    setTimeout(() => {

      // this.detalleOrden.forEach((currentValue, index) => {

        // var content = JSON.parse(JSON.stringify(currentValue.imagenesBase));

        // if (content.length <= 0 && currentValue.imagenesSubidas.length <= 0) {

        //   this.toastr.info("Suba al menos una imagen en el servicio " + currentValue.producto, 'Atención', {
        //     timeOut: 5000,
        //     closeButton: true,
        //     progressBar: true
        //   });

        //   bandera = false;
        //   return;
        // }

        if (bandera) {


          this.ordenesService.scargarImagenesAnalisis(

            this.idOrden,
            this.txtOrdenFisica,
            JSON.stringify(this.detalleOrden),
            localStorage.getItem('token'),

          ).subscribe((resp) => {

            this.spinnerBoolean = false;
            if (resp) {
              this.toastr.success("Multimedia actualizada correctamente y subida a la nube C&M", 'Atención', {
                timeOut: 7000,
                closeButton: true,
                progressBar: true
              });
              this.router.navigateByUrl('sistema/inicio');
            }


          });
        }

      // });

    }, 5000);

  }
}
